import React from 'react';
import PropTypes from 'prop-types';
import {computed} from 'mobx';
import {observer} from 'mobx-react';

import {cn} from 'spa/css';

import './counter-input.less';

import addIcon from 'spa/images/icons/plus_19.svg';
import disabledAddIcon from 'spa/images/icons/plus_19_disabled.svg';
import disabledRemoveIcon from 'spa/images/icons/minus_19_disabled.svg';
import removeIcon from 'spa/images/icons/minus_19.svg';

@observer
class CounterInput extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    forceDisable: PropTypes.bool,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    onAdd: PropTypes.func.isRequired,
    onSubtract: PropTypes.func.isRequired,
    pluralLabel: PropTypes.string.isRequired,
    singularLabel: PropTypes.string.isRequired,
    specialSubLabel: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })),
    title: PropTypes.string,
    value: PropTypes.number.isRequired,
  }

  static defaultProps = {
    className: '',
    forceDisable: false,
    maxValue: null,
    minValue: null,
    specialSubLabel: null,
    title: null,
  }

  @computed get disableAdd() {
    const {forceDisable, maxValue, value} = this.props;

    return value === maxValue || forceDisable;
  }

  @computed get disableRemove() {
    const {forceDisable, minValue, value} = this.props;

    return value === minValue || forceDisable;
  }

  @computed get labelText() {
    const {pluralLabel, singularLabel, value} = this.props;

    return value > 1 ? `${value} ${pluralLabel}` : `${value} ${singularLabel}`;
  }

  @computed get minusIcon() {
    const {disableRemove} = this;

    return !disableRemove ? removeIcon : disabledRemoveIcon;
  }

  @computed get plusIcon() {
    const {disableAdd} = this;

    return !disableAdd ? addIcon : disabledAddIcon;
  }

  @computed get subLabelText() {
    const {specialSubLabel, value} = this.props;

    if (!specialSubLabel) return null;

    const currentValueSubLabel = specialSubLabel.filter(subLabel => subLabel.value === value);

    return currentValueSubLabel.length ? currentValueSubLabel[0].text : null;
  }

  render() {
    const {
      className,
      title,
    } = this.props;
    const {
      disableAdd,
      disableRemove,
      labelText,
      minusIcon,
      plusIcon,
      subLabelText,
    } = this;

    return (
      <div className="counter-input__main-wrapper">
        {title ? (
          <h3 className="counter-input__main-title">
            {title}
          </h3>
        ) : null}
        <div
          className={cn(
            'counter-input',
            className,
          )}>
          <div className="counter-input__button-container">
            <button
              className={cn(
                'counter-input__action-button counter-input__action-button--remove',
                disableRemove && 'counter-input__action-button--disabled',
              )}
              disabled={disableRemove}
              onClick={this.props.onSubtract}
            >
              <img src={minusIcon} alt="" />
            </button>
          </div>
          <p className="counter-input__label">
            {labelText}
            <span className="counter-input__label-sub-text">
              {subLabelText}
            </span>
          </p>
          <div className="counter-input__button-container">
            <button
              className={cn(
                'counter-input__action-button',
                disableAdd && 'counter-input__action-button--disabled',
              )}
              disabled={disableAdd}
              onClick={this.props.onAdd}
            >
              <img src={plusIcon} alt="" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default CounterInput;



// WEBPACK FOOTER //
// ./spa/Components/Form/CounterInput.jsx